// extracted by mini-css-extract-plugin
module.exports = {"textarea":"free-size-text-editor_textarea__o5NBp"};